import { ReactComponent as Svg1Password } from './1Password.svg.es.js';
import { ReactComponent as SvgAndroid } from './Android.svg.es.js';
import { ReactComponent as SvgApple } from './Apple.svg.es.js';
import { ReactComponent as SvgAuthy } from './Authy.svg.es.js';
import { ReactComponent as SvgCircle } from './Circle.svg.es.js';
import { ReactComponent as SvgDuo } from './DUO.svg.es.js';
import { ReactComponent as SvgEvmos } from './Evmos.svg.es.js';
import { ReactComponent as SvgGoogleAuthenticator } from './GoogleAuthenticator.svg.es.js';
import { ReactComponent as SvgNft } from './NFT.svg.es.js';
import { ReactComponent as SvgOkta } from './OKTA.svg.es.js';
import { ReactComponent as SvgSphere } from './Sphere.svg.es.js';
import { ReactComponent as SvgWeb } from './Web.svg.es.js';
import { ReactComponent as SvgZkSync } from './ZKSync.svg.es.js';

const SvgMiscellaneousIcons = {
    'Misc/1Password': Svg1Password,
    'Misc/Android': SvgAndroid,
    'Misc/Apple': SvgApple,
    'Misc/Authy': SvgAuthy,
    'Misc/Circle': SvgCircle,
    'Misc/DUO': SvgDuo,
    'Misc/Evmos': SvgEvmos,
    'Misc/GoogleAuthenticator': SvgGoogleAuthenticator,
    'Misc/NFT': SvgNft,
    'Misc/OKTA': SvgOkta,
    'Misc/Sphere': SvgSphere,
    'Misc/Web': SvgWeb,
    'Misc/ZKSync': SvgZkSync
};

export { SvgMiscellaneousIcons };
//# sourceMappingURL=index.es.js.map
